export default class EsayParam {
	constructor(info) {
		this.pageinfo = {
			
		}
		if( info ){
			this.putBatch(info)
		}
	}
	put(key,val) {
		this[key] = val
	}
	page(limit,page){
		this.pageinfo = {
			limit: limit,
			page: page
		}
	}
	pageCustom(pageCustom){
		this.pageinfo = {
			...pageCustom
		}
	}
	putBatch(info){
		if( info ){
			for( let key in info ){
				if( info[key] ){
					this.put(key,info[key])
				}
			}
		}
	}
}